import { render, staticRenderFns } from "./IconTwitterLight.vue?vue&type=template&id=d4e360d2&"
import script from "./IconTwitterLight.vue?vue&type=script&lang=js&"
export * from "./IconTwitterLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports